import React from "react";
import PropTypes from "prop-types";
import Fieldset from "../common/Fieldset";
import Row from "../common/Row";
import FieldsetSubHeader from "../common/FieldsetSubHeader";
import ScoreSubFieldset from "./ScoreSubFieldset";
import TextInput from "../common/TextInput";

const ScoreFieldset = (props) => {
    const { scores, disabled, meerdereInfras, totaalGewicht, bovenLokaliteitPerInfrastructuur, simulatieDossier} = props;

    let totaalScore = 0;
    let totaalGewogenScore = 0;
    let totaalGewogenPunten = 0;

    const infrastructuren = simulatieDossier.sportinfrastructurenInDeBuurt.filter(i => i.infrastructuurId !== "00000000-0000-0000-0000-000000000000");

    const scoresComponent = scores.map((score, i) => {
        let scoreFieldsetProps = {
            omschrijving: "Criterium \"" + score.omschrijving + "\"",
            score: (score.score ? (score.score).toFixed(2) + "/" + score.punten : 0 + "/" + score.punten),
            wegingsfactor: score.wegingsfactor,
            gewogenScore: score.score && score.wegingsfactor ? (score.score * score.wegingsfactor).toFixed(2) + "/" + (score.punten * score.wegingsfactor) : 0 + "/" + (score.punten * score.wegingsfactor),
            disabled: null
        };

        totaalGewogenScore += score.score * score.wegingsfactor;
        totaalGewogenPunten += score.punten * score.wegingsfactor;
        totaalScore += score.score;

        return (<ScoreSubFieldset {...scoreFieldsetProps} key = {i} />);
    });

    return (
        <Fieldset title="Score">
            {meerdereInfras ? <FieldsetSubHeader>De infrastructuur {infrastructuren.find(i => i.infrastructuurId === bovenLokaliteitPerInfrastructuur.infrastructuurId).naam} behaalde de hoogste score voor bovenlokaliteit:</FieldsetSubHeader> : ""}
            {scoresComponent}
            <Row>
                <TextInput
                    label="Omschrijving"
                    name="Omschrijving"
                    disabled={disabled}
                    value="Totaal gewogen score"
                    size={10}
                    style={{ fontWeight: "bold" }}
                />
                <TextInput
                    label="Totaal gewogen score"
                    name="Totaal gewogen score"
                    disabled={disabled}
                    value={totaalGewogenScore ? (totaalGewogenScore).toFixed(2) + "/" + totaalGewogenPunten : 0 + "/" + totaalGewogenPunten}
                    size={2}
                    style={{ fontWeight: "bold" }}
                />
            </Row>
            <Row>
                <TextInput
                    label="Omschrijving"
                    name="Omschrijving"
                    disabled={disabled}
                    value="Totaal bovenlokaliteit"
                    size={10}
                    style={{ fontWeight: "bold" }}
                />
                <TextInput
                    label="Totaal bovenlokaliteit"
                    name="Totaal bovenlokaliteit"
                    disabled={disabled}
                    value={simulatieDossier.scoreBovenlokaliteit + "/" + (totaalGewogenPunten / totaalGewicht)}
                    size={2}
                    style={{ fontWeight: "bold" }}
                />
            </Row>
        </ Fieldset>
    );
};

ScoreFieldset.propTypes = {
    disabled: PropTypes.bool,
    scores: PropTypes.array,
    meerdereInfras: PropTypes.bool,
    totaalGewicht: PropTypes.number,
    bovenLokaliteitPerInfrastructuur: PropTypes.object,
    simulatieDossier: PropTypes.object
};

export default ScoreFieldset;

